import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[clickStopPropagation]',
  standalone: true
})
export class StopPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
